import React from 'react';
import { BiDataHook } from '@wix/da-bi/pkg/constants';
import { BiContextProvidedValue, BiData, } from '@wix/da-bi/pkg/events';
import CommentIcon from '@wix/da-ds/pkg/Icons/24x24/Comment';
import useDeviationStats from './useDeviationStats';
import Stat from './Stat';
var CommentStat = function (_a) {
    var deviation = _a.deviation, onlyNumbers = _a.onlyNumbers, className = _a.className;
    var _b = useDeviationStats(deviation), comments = _b.comments, isCommentable = _b.isCommentable;
    return !isCommentable ? null : (React.createElement(Stat, { className: className, deviation: deviation, icon: CommentIcon, statNameLocaleKey: "deviation.stats.comments", statCount: comments, onlyNumbers: onlyNumbers, userListType: "comment", dataHook: BiDataHook.DEVIATION_COMMENTS_COUNTER, biData: BiData({
            evid: 2,
            click_info: 'comments',
            sectionname: BiContextProvidedValue,
            widgetname: BiContextProvidedValue,
            typeid: BiContextProvidedValue,
            itemid: BiContextProvidedValue,
        }) }));
};
CommentStat.displayName = 'CommentStat';
export default CommentStat;
//# sourceMappingURL=CommentStat.js.map